import React from 'react';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">{t(translations.about.title)}</h2>
        <p className="section-subtitle">{t(translations.about.subtitle)}</p>

        <div className="about-intro">
          <p>{t(translations.about.intro)}</p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="about-card-icon">{'\u2699\uFE0F'}</div>
            <h3>{t(translations.about.point1Title)}</h3>
            <p>{t(translations.about.point1Desc)}</p>
          </div>
          <div className="about-card">
            <div className="about-card-icon">{'\u{1F4B0}'}</div>
            <h3>{t(translations.about.point2Title)}</h3>
            <p>{t(translations.about.point2Desc)}</p>
          </div>
          <div className="about-card">
            <div className="about-card-icon">{'\u{1F3E0}'}</div>
            <h3>{t(translations.about.point3Title)}</h3>
            <p>{t(translations.about.point3Desc)}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
